import { Div, Collection, Link } from "@tblabs/truffle";


export class EntryEdit<T> extends Div
{
    protected LeftSide = new Div().FloatLeft().WidthPercent(90);

    constructor(item: T, collection: Collection<T>)
    {
        super();
        this.Background("#ccc").Margin(16).ClearBoth();

        const entryControlSection = new Div().FloatRight().WidthPercent(10)
            .Append(
                collection.CanSwapUp(item) && new Link("⬆️")
                    .OnClick(() => collection.SwapUp(item)),
                collection.CanSwapDown(item) && new Link("⬇️")
                    .OnClick(() => collection.SwapDown(item)),
                new Link("✖️").OnClick(() =>
                {
                    if (confirm(`Usunąć?`))
                        collection.Remove(item);
                })
            );

        this.Append(
            this.LeftSide,
            entryControlSection,
            // new Div().ClearBoth(),
        );
    }
}
